export enum BaseDialogResponseStatus {
    Success = 'success',
    Error = 'error',
    Cancelled = 'canceled',
}
